// extracted by mini-css-extract-plugin
export default {"progressPlaceholder":"OAxQ0GnH01sbQsQwXw9y"};